$(function () {
  $(window).on('resize', function () {
    fixedNav();
  });

  $(window).on('scroll', function () {
    fixedNav();
  });
  fixedNav();
});

function fixedNav() {
  var scrollTop = $(window).scrollTop();

  if (scrollTop >= 46 + 6) {
    $('body').addClass('fixed-nav');
  } else {
    $('body').removeClass('fixed-nav');
  }
}
